export { RecentlyViewed } from './recently-viewed'
